import { createSlice } from "@reduxjs/toolkit";
import PropTypes from "prop-types";

// ----------------------------------------------------------------------

const hub = {
  name: PropTypes.string,
  hub: PropTypes.object,
  connectedHub: PropTypes.bool,
};

const initialState = {
  isLoading: false,
  hubMesas: null,
  hubSessiones: null,
  hubUser: null,
  hubSessionUser: null,
  hubProduct: null,
  hubStartSession: null,
  hubNotificationRestaurante: null,
  hubNotificationSession: null,
  hubPedido: null,
  hubLogs: null,
  hubDisplayKitchen: null,
  hubWorkerStatus: null,
  hubBooking: null,
  hubCashDrawer: null,
};

const slice = createSlice({
  name: "hub",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    connectHub(state, action) {
      state.connectedHub = action.payload.connectionStarted;
      state.hub = action.payload;
    },
    addHubMesas(state, action) {
      state.hubMesas = action.payload;
    },
    addHubSessiones(state, action) {
      state.hubSessiones = action.payload;
    },
    addHubUser(state, action) {
      state.hubUser = action.payload;
    },
    addHubStartSession(state, action) {
      state.hubStartSession = action.payload;
    },
    addHubNotificationRestaurante(state, action) {
      state.hubNotificationRestaurante = action.payload;
    },
    addHubNotificationSession(state, action) {
      state.hubNotificationSession = action.payload;
    },
    addHubPedido(state, action) {
      state.hubPedido = action.payload;
    },
    addHubProduct(state, action) {
      state.hubProduct = action.payload;
    },
    addHubLogs(state, action) {
      state.hubLogs = action.payload;
    },
    addHubSessionUser(state, action) {
      state.hubSessionUser = action.payload;
    },
    addHubDisplayKitchen(state, action) {
      state.hubDisplayKitchen = action.payload;
    },
    addHubWorkerStatus(state, action) {
      state.hubWorkerStatus = action.payload;
    },
    addHubBooking(state, action) {
      state.hubBooking = action.payload;
    },
    addHubCashDrawer(state, action) {
      state.hubCashDrawer = action.payload;
    },
    cleanAll(state, action) {
      state.hubMesas = null;
      state.hubSessiones = null;
      state.hubUser = null;
      state.hubStartSession = null;
      state.hubNotificationRestaurante = null;
      state.hubNotificationSession = null;
      state.hubPedido = null;
      state.hubProduct = null;
      state.hubLogs = null;
      state.hubSessionUser = null;
      state.hubDisplayKitchen = null;
      state.hubWorkerStatus = null;
      state.hubBooking = null;
      state.hubCashDrawer = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { cleanAll } = slice.actions;

export function connectToHubMesas(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubMesas(hub));
  };
}

export function connectToHubSessiones(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubSessiones(hub));
  };
}

export function connectToHubUser(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubUser(hub));
  };
}

export function connectToStartHubMesa(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubStartSession(hub));
  };
}

export function connectToHubNotificationRestaurante(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubNotificationRestaurante(hub));
  };
}

export function connectToHubNotificationSession(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubNotificationSession(hub));
  };
}

export function connectToHubPedido(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubPedido(hub));
  };
}

export function connectToHubProduct(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubProduct(hub));
  };
}

export function connectToHubLogs(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubLogs(hub));
  };
}

export function connectToHubSessionUser(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubSessionUser(hub));
  };
}

export function connectToHubDisplayKitchen(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubDisplayKitchen(hub));
  };
}

export function connectToHubWorkerStatus(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubWorkerStatus(hub));
  };
}

export function connectToHubCashDrawer(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubCashDrawer(hub));
  };
}

export function connectToHubBooking(hub) {
  return async (dispatch) => {
    dispatch(slice.actions.addHubBooking(hub));
  };
}
